import queryString from 'query-string';
import { sprintf } from 'sprintf-js';

import { LISTING_TYPE_HUMAN_NAME_MAP } from 'utils/constants/general/listingTypeHumanNameMap';
import { updateObject } from 'utils/functional';

export function getSocialLink(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  socialType: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  link: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  message: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listingType: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subject: any,
): string {
  switch (socialType) {
    case 'facebook': {
      const qs = queryString.stringify(
        updateObject(
          {
            u: link,
          },
          message
            ? {
                title: message,
              }
            : {},
        ),
      );
      return `https://facebook.com/sharer/sharer.php?${qs}`;
    }

    case 'x': {
      const qs = queryString.stringify({
        text: message,
        url: link,
      });
      return `https://x.com/intent/tweet/?${qs}`;
    }

    case 'email': {
      let body = getText('Click the link below to see the page on Idealist:');

      if (message) {
        body = message;
      } else if (listingType === 'CMS_PAGE') {
        body = getText('Click the link below to see the article on Idealist:');
      } else if (listingType === 'URL') {
        body = getText(
          'Click the link below to see the article from Idealist:',
        );
      } else if (listingType) {
        sprintf(
          getText(
            'Click the link below to see the %(type)s listing on Idealist:',
          ),
          {
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            type: LISTING_TYPE_HUMAN_NAME_MAP[listingType],
          },
        );
      }

      const qs = queryString.stringify({
        subject,
        body: `${body}\n\n${link}`,
      });
      return `mailto:?${qs}`;
    }

    case 'linkedin': {
      const qs = queryString.stringify({
        url: link,
        mini: true,
        title: message,
      });
      return `https://www.linkedin.com/shareArticle?${qs}`;
    }

    default:
      throw new Error(`Invalid social type ${socialType}`);
  }
}
